import { createContext, type MutableRefObject } from 'react';

export interface HotkeyBinding {
  /** Нормализованная комбинация: `'Escape'`, `'Insert'`, `'F2'`, `'Delete'`, `'ArrowUp'`, либо с
   *  модификатором — `'Ctrl+S'` (см. `normalizeCombo` в HotkeyProvider). */
  combo: string;
  /** Показывается в `<HotkeyHint>` — единый источник правды с реальным поведением. */
  description: string;
  handler: () => void;
}

export interface HotkeyScope {
  id: string;
  bindingsRef: MutableRefObject<HotkeyBinding[]>;
}

export interface HotkeyRegistry {
  push: (scope: HotkeyScope) => void;
  remove: (id: string) => void;
  /** Переносит скоуп в конец стека (высший приоритет) — вызывается при получении окном фокуса
   *  (клик), т.к. окна без маски можно переключать в любом порядке, а не только по монтированию. */
  touch: (id: string) => void;
}

/** `null` вне `HotkeyProvider` — компоненты, использующие `useHotkeyScope`, в этом случае просто
 *  не регистрируют горячие клавиши (не бросают), чтобы не тянуть провайдер в каждый unit-тест. */
export const HotkeyContext = createContext<HotkeyRegistry | null>(null);
